export default "__VITE_ASSET__18f23447__"